function get (url) {
	// Return a new promise.
	return new Promise(function(resolve, reject) {
		// Do the usual XHR stuff
		var req = new XMLHttpRequest();
		req.open('GET', url);

		req.onload = function() {
			if (req.status == 200) {
				resolve(req.response);
			}
			else {
				reject(req);
			}
		};

		req.onerror = function(error) {
			reject(Error("Network Error: " + error));
		};

		req.send();
	});
};

function post(url, formData) {
	return new Promise(function (resolve, reject) {
		var req = new XMLHttpRequest();
		req.open('POST', url);

		req.onload = () => {
			if (req.status == 200) {
				resolve(req.response);
			} else {
				reject(req);
			}
		};

		req.onerror = function(error) {
			reject(Error("Network Error: " + error));
		}

		req.send(formData);
	});
}

exports.post = post;
exports.get = get;
